import { FlexContainer } from '@cmg/common';
import styled from 'styled-components';

export const StyledFlexContainer = styled(FlexContainer)`
  justify-content: space-between;
  padding: 8px 0;
`;
